module.exports = __webpack_public_path__ + "static/media/hair_cut.1a8ea823.jpg";